import { Skeleton } from "@material-ui/lab";
import {
  LoadingContainer,
  LoadingHeaderImg,
  LoadingItem,
  HeaderTitle,
} from "./style";

const Loading = (props) => {
  const { isLoading } = props;

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        {[1, 2, 3, 4, 5].map((key) => (
          <LoadingItem key={key} className="headerFoodItem">
            <LoadingHeaderImg className="headerFoodImg mt-2 ml-2">
              <Skeleton
                variant="circle"
                animation="wave"
                width={50}
                height={50}
              />
            </LoadingHeaderImg>
            <HeaderTitle className="d-flex justify-content-center mt-2">
              <Skeleton animation="wave" width={60} height={10} />
            </HeaderTitle>
          </LoadingItem>
        ))}
      </LoadingContainer>
    </>
  );
};

export default Loading;
